// Generated by Melange

import * as Buhta_controlapis__Buhta_control_v1alpha1_prop_information from "./buhta_control_v1alpha1_prop_information.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_wkt__Google_protobuf_field_mask from "../../third_party/google_wkt/gen/google_protobuf_field_mask.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetPropInformationRequest = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_prop_information_service.ml",
      507,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetPropInformationResponse = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_prop_information_service.ml",
      567,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdatePropInformationRequest = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_prop_information_service.ml",
      628,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdatePropInformationResponse = Caml_module.init_mod([
      "proto/controlapis/gen/buhta_control_v1alpha1_prop_information_service.ml",
      691,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.control.v1alpha1.GetPropInformationRequest";
}

function make(expandOpt, param) {
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          expand: expand
        };
}

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "expand",
                    "expand"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._2(serialize, writer, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(expand) {
  return {
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.GetPropInformationRequest", spec(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.expand);
  };
}

function constructor$1(expand) {
  return {
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.GetPropInformationRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetPropInformationRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.control.v1alpha1.GetPropInformationResponse";
}

function make$1(info, param) {
  return {
          info: info
        };
}

const $$let = Buhta_controlapis__Buhta_control_v1alpha1_prop_information.Buhta.Control.V1alpha1.PropInformation;

const merge_info = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "info",
            "info"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          info: Curry._2(merge_info, t1.info, t2.info)
        };
}

function spec$1(param) {
  const $$let = Buhta_controlapis__Buhta_control_v1alpha1_prop_information.Buhta.Control.V1alpha1.PropInformation;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "info",
                    "info"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.info);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(info) {
  return {
          info: info
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.GetPropInformationResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.info);
  };
}

function constructor$3(info) {
  return {
          info: info
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.GetPropInformationResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetPropInformationResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.control.v1alpha1.UpdatePropInformationRequest";
}

function make$2(info, field_mask, param) {
  return {
          info: info,
          field_mask: field_mask
        };
}

const $$let$1 = Buhta_controlapis__Buhta_control_v1alpha1_prop_information.Buhta.Control.V1alpha1.PropInformation;

const merge_info$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "info",
            "info"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

const $$let$2 = Google_wkt__Google_protobuf_field_mask.Google.Protobuf.FieldMask;

const merge_field_mask = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "field_mask",
            "fieldMask"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              })
        ]));

function merge$2(t1, t2) {
  return {
          info: Curry._2(merge_info$1, t1.info, t2.info),
          field_mask: Curry._2(merge_field_mask, t1.field_mask, t2.field_mask)
        };
}

function spec$2(param) {
  const $$let = Buhta_controlapis__Buhta_control_v1alpha1_prop_information.Buhta.Control.V1alpha1.PropInformation;
  const $$let$1 = Google_wkt__Google_protobuf_field_mask.Google.Protobuf.FieldMask;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "info",
                    "info"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "field_mask",
                        "fieldMask"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let$1.name,
                            make: $$let$1.make,
                            from_proto: $$let$1.from_proto,
                            from_proto_exn: $$let$1.from_proto_exn,
                            to_proto: $$let$1.to_proto,
                            to_proto$p: $$let$1.to_proto$p,
                            merge: $$let$1.merge,
                            to_json: $$let$1.to_json,
                            from_json_exn: $$let$1.from_json_exn,
                            from_json: $$let$1.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._3(serialize$2, writer, param.info, param.field_mask);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(info, field_mask) {
  return {
          info: info,
          field_mask: field_mask
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.UpdatePropInformationRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.info, param.field_mask);
  };
}

function constructor$5(info, field_mask) {
  return {
          info: info,
          field_mask: field_mask
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.UpdatePropInformationRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdatePropInformationRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.control.v1alpha1.UpdatePropInformationResponse";
}

function make$3(info, param) {
  return {
          info: info
        };
}

const $$let$3 = Buhta_controlapis__Buhta_control_v1alpha1_prop_information.Buhta.Control.V1alpha1.PropInformation;

const merge_info$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "info",
            "info"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

function merge$3(t1, t2) {
  return {
          info: Curry._2(merge_info$2, t1.info, t2.info)
        };
}

function spec$3(param) {
  const $$let = Buhta_controlapis__Buhta_control_v1alpha1_prop_information.Buhta.Control.V1alpha1.PropInformation;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "info",
                    "info"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.info);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(info) {
  return {
          info: info
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.control.v1alpha1.UpdatePropInformationResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.info);
  };
}

function constructor$7(info) {
  return {
          info: info
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.control.v1alpha1.UpdatePropInformationResponse", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdatePropInformationResponse, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

const getPropInformation_0 = {
  name: GetPropInformationRequest.name,
  make: GetPropInformationRequest.make,
  from_proto: GetPropInformationRequest.from_proto,
  from_proto_exn: GetPropInformationRequest.from_proto_exn,
  to_proto: GetPropInformationRequest.to_proto,
  to_proto$p: GetPropInformationRequest.to_proto$p,
  merge: GetPropInformationRequest.merge,
  to_json: GetPropInformationRequest.to_json,
  from_json_exn: GetPropInformationRequest.from_json_exn,
  from_json: GetPropInformationRequest.from_json
};

const getPropInformation_1 = {
  name: GetPropInformationResponse.name,
  make: GetPropInformationResponse.make,
  from_proto: GetPropInformationResponse.from_proto,
  from_proto_exn: GetPropInformationResponse.from_proto_exn,
  to_proto: GetPropInformationResponse.to_proto,
  to_proto$p: GetPropInformationResponse.to_proto$p,
  merge: GetPropInformationResponse.merge,
  to_json: GetPropInformationResponse.to_json,
  from_json_exn: GetPropInformationResponse.from_json_exn,
  from_json: GetPropInformationResponse.from_json
};

const getPropInformation = [
  getPropInformation_0,
  getPropInformation_1
];

const updatePropInformation_0 = {
  name: UpdatePropInformationRequest.name,
  make: UpdatePropInformationRequest.make,
  from_proto: UpdatePropInformationRequest.from_proto,
  from_proto_exn: UpdatePropInformationRequest.from_proto_exn,
  to_proto: UpdatePropInformationRequest.to_proto,
  to_proto$p: UpdatePropInformationRequest.to_proto$p,
  merge: UpdatePropInformationRequest.merge,
  to_json: UpdatePropInformationRequest.to_json,
  from_json_exn: UpdatePropInformationRequest.from_json_exn,
  from_json: UpdatePropInformationRequest.from_json
};

const updatePropInformation_1 = {
  name: UpdatePropInformationResponse.name,
  make: UpdatePropInformationResponse.make,
  from_proto: UpdatePropInformationResponse.from_proto,
  from_proto_exn: UpdatePropInformationResponse.from_proto_exn,
  to_proto: UpdatePropInformationResponse.to_proto,
  to_proto$p: UpdatePropInformationResponse.to_proto$p,
  merge: UpdatePropInformationResponse.merge,
  to_json: UpdatePropInformationResponse.to_json,
  from_json_exn: UpdatePropInformationResponse.from_json_exn,
  from_json: UpdatePropInformationResponse.from_json
};

const updatePropInformation = [
  updatePropInformation_0,
  updatePropInformation_1
];

const V1alpha1_PropInformationService = {
  GetPropInformation: {
    name: "/buhta.control.v1alpha1.PropInformationService/GetPropInformation",
    package_name: "buhta.control.v1alpha1",
    service_name: "PropInformationService",
    method_name: "GetPropInformation",
    $$Request: {
      name: GetPropInformationRequest.name,
      make: GetPropInformationRequest.make,
      from_proto: GetPropInformationRequest.from_proto,
      from_proto_exn: GetPropInformationRequest.from_proto_exn,
      to_proto: GetPropInformationRequest.to_proto,
      to_proto$p: GetPropInformationRequest.to_proto$p,
      merge: GetPropInformationRequest.merge,
      to_json: GetPropInformationRequest.to_json,
      from_json_exn: GetPropInformationRequest.from_json_exn,
      from_json: GetPropInformationRequest.from_json
    },
    $$Response: {
      name: GetPropInformationResponse.name,
      make: GetPropInformationResponse.make,
      from_proto: GetPropInformationResponse.from_proto,
      from_proto_exn: GetPropInformationResponse.from_proto_exn,
      to_proto: GetPropInformationResponse.to_proto,
      to_proto$p: GetPropInformationResponse.to_proto$p,
      merge: GetPropInformationResponse.merge,
      to_json: GetPropInformationResponse.to_json,
      from_json_exn: GetPropInformationResponse.from_json_exn,
      from_json: GetPropInformationResponse.from_json
    }
  },
  getPropInformation: getPropInformation,
  UpdatePropInformation: {
    name: "/buhta.control.v1alpha1.PropInformationService/UpdatePropInformation",
    package_name: "buhta.control.v1alpha1",
    service_name: "PropInformationService",
    method_name: "UpdatePropInformation",
    $$Request: {
      name: UpdatePropInformationRequest.name,
      make: UpdatePropInformationRequest.make,
      from_proto: UpdatePropInformationRequest.from_proto,
      from_proto_exn: UpdatePropInformationRequest.from_proto_exn,
      to_proto: UpdatePropInformationRequest.to_proto,
      to_proto$p: UpdatePropInformationRequest.to_proto$p,
      merge: UpdatePropInformationRequest.merge,
      to_json: UpdatePropInformationRequest.to_json,
      from_json_exn: UpdatePropInformationRequest.from_json_exn,
      from_json: UpdatePropInformationRequest.from_json
    },
    $$Response: {
      name: UpdatePropInformationResponse.name,
      make: UpdatePropInformationResponse.make,
      from_proto: UpdatePropInformationResponse.from_proto,
      from_proto_exn: UpdatePropInformationResponse.from_proto_exn,
      to_proto: UpdatePropInformationResponse.to_proto,
      to_proto$p: UpdatePropInformationResponse.to_proto$p,
      merge: UpdatePropInformationResponse.merge,
      to_json: UpdatePropInformationResponse.to_json,
      from_json_exn: UpdatePropInformationResponse.from_json_exn,
      from_json: UpdatePropInformationResponse.from_json
    }
  },
  updatePropInformation: updatePropInformation
};

const V1alpha1 = {
  GetPropInformationRequest: GetPropInformationRequest,
  GetPropInformationResponse: GetPropInformationResponse,
  UpdatePropInformationRequest: UpdatePropInformationRequest,
  UpdatePropInformationResponse: UpdatePropInformationResponse,
  PropInformationService: V1alpha1_PropInformationService
};

const Control = {
  V1alpha1: V1alpha1
};

const Buhta = {
  Control: Control
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetPropInformationRequest Not a pure module */
